export default __webpack_public_path__ + "d0fa4355e491cbe9b4428913c3b530ef.png";